import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'playground',
  children: {
    breadcrumbs: {
      path: 'breadcrumbs',
      children: {
        item: {
          path: 'employee/:employeeId',
          children: {
            subitem: {
              path: 'contract/:contractId',
            },
          },
        },
      },
    },
    one: {
      path: 'one',
    },
  },
} as const satisfies Location
